exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container{border-top:1px solid #dcdfe6;background:#fff}.table-container .custom-header{background:#f5f7fa!important;color:#333;border-bottom:1px solid #dcdfe6!important}.table-container .el-table--enable-row-hover .el-table__body tr:hover>td{background-color:#eaf3fd}.table-container .pagination-container{margin-top:10px;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.1@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f260e3ea","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!./node_modules/_vue-loader@13.7.1@vue-loader/lib/selector.js?type=styles&index=0!./src/components/BasicTable/BasicTable.vue
// module id = 4
// module chunks = 0